import {Directive, HostListener} from '@angular/core';
import {Location} from '@angular/common';

@Directive({
  selector: '[backButton]'
})
export class BackButtonDirective {

  constructor(
    private location: Location,
    // private naviSvc: NavigationService,
  ) { }

  @HostListener('click')
  onClick(): void {
    // this.naviSvc.back();
    this.location.back();
  }
}
